import React, {Component} from 'react';
import './pageCss/Photography.css';
import StrCom from '../components/PhotoCom/StrCom';
import ConCom from '../components/PhotoCom/ConCom';
import PrtCom from '../components/PhotoCom/PrtCom';
import NatCom from '../components/PhotoCom/NatCom';

class Photography extends Component {
    constructor() {
        super();
        //Set default message
        this.state = {
        category: [ <PrtCom />, <NatCom />, <ConCom /> , <StrCom />],
        imgMaps: 0
        }
      }

      changeCategory(e){
        this.setState({ imgMaps: e.currentTarget.dataset.id  });
      };

      render(){ 
          
  return (
    <div class="photgraphy">
        <div class="photo-view-section-1">
            <div class="phs1-item">
                <ul class="phs1-ul font">
                    <li class="phs1-li" onClick={this.changeCategory.bind(this)} data-id="0">Portraits </li>
                    <li class="phs1-li" onClick={this.changeCategory.bind(this)} data-id="1">Nature</li>
                    <li class="phs1-li" onClick={this.changeCategory.bind(this)} data-id="2">Concert</li>
                    <li class="phs1-li" onClick={this.changeCategory.bind(this)} data-id="3">Street</li>
                </ul>
            </div>
            {this.state.category[this.state.imgMaps]}
        </div>
    </div>
  );
}
}

export default Photography;
